// extracted by mini-css-extract-plugin
module.exports = {"footer":"dece2e673c--footer--27TXc","text":"dece2e673c--text--he9xp"};